var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNOx = function SvgNOx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "auto",
      fill: "currentColor"
    },
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#677580",
    strokeMiterlimit: 10,
    strokeWidth: 4.27,
    d: "M63.254 127.065c-11.868 1.139-24.339.325-26.11-13.127-1.542-11.764 9.618-21.483 21.486-21.483A21.451 21.451 0 0 1 91.257 74.11a30.673 30.673 0 0 1 58.258 13.425c0 .416-.046.818-.062 1.227a21.47 21.47 0 0 1 14.38 20.26c0 11.864-9.619 17.654-21.487 17.654M76.718 55.732a8.366 8.366 0 1 0 0-16.732 8.366 8.366 0 0 0 0 16.732ZM56.786 70.492a6.688 6.688 0 1 0 0-13.377 6.688 6.688 0 0 0 0 13.377Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#677580",
    d: "M87.693 86.34h3.534v20.59h-2.833l-11.04-14.37v14.37h-3.505V86.34h2.803l11.04 14.34zm17.146 20.853q-3.008 0-5.228-1.285-2.19-1.286-3.388-3.68t-1.197-5.608q0-3.213 1.168-5.579 1.197-2.394 3.417-3.68 2.22-1.285 5.228-1.285 3.009 0 5.199 1.285 2.22 1.286 3.388 3.68 1.197 2.367 1.197 5.579 0 3.213-1.197 5.608t-3.417 3.68q-2.191 1.284-5.17 1.285"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#677580",
    strokeMiterlimit: 10,
    strokeWidth: 4.27,
    d: "m78.328 118.925-.325 45.894a.649.649 0 0 1-1.188.376l-5.393-7.431 6.545 9.022 6.222-9.038M99.817 115.813l-.38 32.592a.762.762 0 0 1-1.382.434l-6.27-8.642 7.617 10.499 7.24-10.518M120.063 126.285l-.325 36.321a.648.648 0 0 1-1.191.376l-5.387-7.425 6.546 9.019 6.221-9.035"
  })));
};
export default SvgNOx;